import { useRef, Fragment } from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-css";
import "prismjs/themes/prism.css";
import "./CodeEditor.css";

const CodeEditor = ({ value, onChange, language = "javascript" }) => {
    return (
        <Editor
            textareaClassName="form-control"
            value={value}
            onValueChange={onChange}
            highlight={(code) => highlight(code, languages[language], language)}
            padding={10}
            autoCapitalize="none"
            style={{
                fontFamily: "monospace",
                fontSize: 15,
                background: "#ffffff",
                color: "#000000",
                border: "1px solid #ced4da",
                borderRadius: "8px",
                minHeight: 200,
            }}
        />
    );
};

export default CodeEditor;
